import LumaResourceWorkspace, {lumaMoney} from '../../../components/admin/LumaResourceWorkspace';
import AdminTable from '../../../components/admin/AdminTable';
﻿import React, { useEffect, useState, useCallback } from 'react';
import Loading from '../../../components/Loading';
import { Edit, Trash2, History, Plus } from 'lucide-react';
import { fetchEmpresasConfianza, EmpresaConfianza } from '../../../services/empresaConfianzaService';
import { AddEmpresasConfianzaPage } from '../../../components/EmpresaConfianza/AddEmpresasConfianzaPage';
import { EditEmpresasConfianzaPage } from '../../../components/EmpresaConfianza/EditEmpresasConfianzaPage';
import { DeleteEmpresasConfianzaPage } from '../../../components/EmpresaConfianza/DeleteEmpresasConfianzaPage';
import Pagination from '../../../components/Pagination/Pagination';
import ExpiredSessionModal from '../../../components/Expired/ExpiredSessionModal';
import { useSessionExpiration } from '../../../hooks/useSessionExpiration';
import { useAuth } from '../../../context/AuthContext';
import { useModelPermission } from '../../../hooks/useModelPermission';

const EmpresasConfianzaPage: React.FC = () => {
  const [empresas, setEmpresas] = useState<EmpresaConfianza[]>([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState<EmpresaConfianza | null>(null);
  const [empresaToDelete, setEmpresaToDelete] = useState<EmpresaConfianza | null>(null);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const { isSessionExpired, setIsSessionExpired } = useSessionExpiration();
  const { logout, user } = useAuth();

  const userLevelId = user?.user_level_id ?? 0;
  const perm = useModelPermission('empresaconfianza', userLevelId); // Ajusta el nombre del modelo según tu backend

  const loadEmpresas = useCallback(async () => {
    if (!perm?.can_read) {
      setEmpresas([]);
      return;
    }
    try {
      const data = await fetchEmpresasConfianza();
      setEmpresas(data.sort((a, b) => a.id - b.id));
    } catch (error) {
      /* Browser diagnostics omitted. */
      setEmpresas([]);
    }
  }, [perm?.can_read]);

  useEffect(() => {
    loadEmpresas();
  }, [loadEmpresas]);

  const handleDeleteSuccess = () => {
    setEmpresas(prev => prev.filter(e => e.id !== empresaToDelete?.id));
    setEmpresaToDelete(null);
  };

  const handleAddSuccess = () => {
    loadEmpresas(); // Recarga completa después de agregar
  };

  const handleEditSuccess = () => {
    loadEmpresas(); // Recarga completa después de editar
  };

  // Paginación
  const totalPages = Math.ceil(empresas.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const displayedEmpresas = empresas.slice(startIndex, startIndex + itemsPerPage);

  if (perm === null) return <Loading text="Cargando empresas de confianza..." />;

  return <><LumaResourceWorkspace title="Empresas de confianza" description="Consulta y gestiona la información de tu coworking." group="Contenido" rows={empresas} columns={[{key:'nombre',label:'Nombre'},{key:'rubro',label:'Rubro'},{key:'descripcion',label:'Descripción'},{key:'orden',label:'Orden'},{key:'activo',label:'Estado'}]} idKey="id" nameKey="nombre" statusKey="activo" canRead={perm?.can_read} onCreate={perm?.can_create?()=>{setIsAddOpen(true)}:undefined} onEdit={perm?.can_update?setSelectedEmpresa:undefined} onDelete={perm?.can_delete?setEmpresaToDelete:undefined}/><AddEmpresasConfianzaPage
          isOpen={isAddOpen}
          onClose={() => setIsAddOpen(false)}
          onSuccess={handleAddSuccess}
        />{selectedEmpresa && (
          <EditEmpresasConfianzaPage
            isOpen={!!selectedEmpresa}
            onClose={() => setSelectedEmpresa(null)}
            empresa={selectedEmpresa}
            onSuccess={handleEditSuccess}
          />
        )}{empresaToDelete && (
          <DeleteEmpresasConfianzaPage
            isOpen={!!empresaToDelete}
            onClose={() => setEmpresaToDelete(null)}
            empresa={empresaToDelete}
            onSuccess={handleDeleteSuccess}
          />
        )}<ExpiredSessionModal
          isOpen={isSessionExpired}
          onClose={async () => {
            setIsSessionExpired(false);
            await logout();
          }}
        /></>;
};

export default EmpresasConfianzaPage;

